import vidImg1 from "../arktemis media/pexels-phamnghia-1206593.jpg";
import vidImg2 from "../arktemis media/pexels-quintingellar-2199293.jpg";
import vidImg3 from "../arktemis media/pexels-tomfisk-3057960.jpg";
import vidImg4 from "../arktemis media/pexels-artempodrez-5716001.jpg";
import vidImg5 from "../arktemis media/pexels-rob-zohrab-87688304-9754753.jpg";
import vidImg6 from "../arktemis media/pexels-mikhail-nilov-7731402.jpg";
import vidImg7 from "../arktemis media/pexels-kelly-1179532-2876514.jpg";
import vidImg8 from "../arktemis media/pexels-cottonbro-5989933.jpg";

export const cards = [
    {
      title: "EcoNexus",
      description: "Integrated Land-Water-Energy Systems",
      image: vidImg7,
    },
    {
      title: "AgroBiome",
      description: "Precision Farming & Regenerative Agriculture",
      image: vidImg1,
    },
    {
      title: "CyberSphere",
      description: "Robotics, IoT & Smart Automation",
      image: vidImg8,
    },
    {
      title: "ImpactForge",
      description: "Strategy, ESG & R&D Advisory",
      image: vidImg4,
    },
  ];

  export const services = [
    {
      img: vidImg1,
      alt: "Natural Resource Management Frameworks",
      route: "/service",
    },
    {
      img: vidImg2,
      alt: "Sustainability & ESG Advisory",
      route: "/service",
    },
    {
      img: vidImg3,
      alt: "Sustainable Supply Chain & Logistics",
      route: "/service",
    },
    {
      img: vidImg4,
      alt: "Technology‑Driven Business Optimization",
      route: "/service",
    },
    {
      img: vidImg5,
      alt: "Sustainable Infrastructure & Smart Development",
      route: "/service",
    },
    {
      img: vidImg6,
      alt: "Regulatory & Policy Compliance",
      route: "/service",
    },
  ];
